// Which sign-in method this device used last, so the login screen can point
// returning users at it. Kept across sign-out on purpose: that's when it helps.
export type LoginMethod = 'google' | 'email'

const KEY = 'lastLoginMethod'

export function getLastLogin(): LoginMethod | null {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'google' || v === 'email' ? v : null
  } catch {
    return null
  }
}

export function setLastLogin(method: LoginMethod) {
  try {
    localStorage.setItem(KEY, method)
  } catch {
    // private mode: no hint next time
  }
}
